import { mdiBookOpenPageVariantOutline } from '@mdi/js'

export default {
  title: 'Library',
  to: 'library-list',
  icon: mdiBookOpenPageVariantOutline,
  resource: 'LibraryAdmin',
  action: 'read',
}
